import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import { isNull } from "@/functions/Util";

export default class SubGrupoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let subgroup = model;

        if (isNull(subgroup.idsubgrupoprodutoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        if (isNull(subgroup.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        if (isNull(subgroup.grupoproduto) || isNull(subgroup.grupoproduto.idgrupoproduto) ){
            refs.gpSelect.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }

        return validated;
    }

}